import * as React from 'react';
import BuyerSignupForm from '../buyer_signup_form/BuyerSignupForm';
import { Layout, Row, Col } from 'antd';

import * as queryString from 'querystring';
import { withRouter } from 'react-router';

const { Content } = Layout;
const style = require('./BuyerSignupPage.less');

export default withRouter<any, any>(
	class BuyerSignupPage extends React.Component<any, any> {
		render() {
			const { location } = this.props;
			let searchString = location.search;
			if (searchString[0] === '?') {
				searchString = searchString.slice(1);
			}
			const queryParams = queryString.parse(searchString);
			const email = queryParams.email;
			const nameGiven = queryParams.nameGiven;
			const nameFamily = queryParams.nameFamily;

			return (
				<Content
					className="signUpPage"
					style={{
						height: '100vh',
						display: 'flex',
						backgroundColor: '#220e3f',
						justifyContent: 'center',
						alignItems: 'center',
					}}
				>
					{/*<BackTop/>*/}
					<Row
						style={{
							maxWidth: 800,
							boxShadow: 'rgba(0,0,0,0.5) 10px 10px 50px',
							width: '100%',
							margin: 'auto',
						}}
					>
						<Col sm={24} md={10}>
							<div style={{ background: '#391769', padding: 40, height: '100%' }}>
								<div
									style={{
										width: '100%',
										height: 80,
										backgroundSize: 'contain',
										backgroundRepeat: 'no-repeat',
										backgroundPosition: 'center',
										backgroundImage: `url('https://s3.amazonaws.com/emptor-data-assets/images/openwrench-logos/openwrenchlogo-white-facilities.png')`,
									}}
								/>
							</div>
						</Col>
						<Col sm={24} md={14}>
							<div style={{ padding: '56px 40px', background: 'white' }}>
								<h4 style={{ marginBottom: 24 }}>Sign Up</h4>
								<BuyerSignupForm email={email} nameGiven={nameGiven} nameFamily={nameFamily} />
							</div>
						</Col>
					</Row>
				</Content>
			);
		}
	}
);
